<script lang="ts">
  export let singleCol = false
</script>

<div class="course-partners" class:v-single="{singleCol}">
  <div class="partners-card">
    <slot />
  </div>
</div>

<style type="text/scss" lang="scss" scoped>
  .course-partners {
    @apply flex;
  }

  .partners-card {
    @apply grid;
    @apply gap-11 md:gap-8;
    @apply grid-cols-3 md:grid-cols-4;
    @apply items-center;
    @apply rounded shadow-md;
    @apply bg-white;
    @apply px-2.5 py-6;
    @apply md:px-6 md:py-10;
    @apply w-full md:max-w-xl;
    @apply ml-auto;

    .v-single & {
      @apply grid-cols-1;
    }
  }

  :global(.course-partners > .partners-card > a) {
    @apply flex items-center;

    &::after {
      content: "";
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='currentColor'%3E%3Cpath fill-rule='evenodd' d='M15.4625,9.2925 L11.5825,13.1725 L7.7025,9.2925 C7.3125,8.9025 6.6825,8.9025 6.2925,9.2925 C5.9025,9.6825 5.9025,10.3125 6.2925,10.7025 L10.8825,15.2925 C11.2725,15.6825 11.9025,15.6825 12.2925,15.2925 L16.8825,10.7025 C17.2725,10.3125 17.2725,9.6825 16.8825,9.2925 C16.4925,8.9125 15.8525,8.9025 15.4625,9.2925 Z' clip-rule='evenodd' /%3E%3C/svg%3E");
      @apply w-5 h-5;
      @apply ml-auto;
      @apply transform translate-x-0;
      @apply transition-transform duration-300;
    }

    &:hover::after {
      @apply transform translate-x-2;
    }
  }

  :global(.course-partners:not(.v-single) > .partners-card > *) {
    @apply mx-auto;
  }
</style>
